<template>
  <div class="nav-item dropdown ml-2">

    <span
      class="dropdown-toggle ml-2"
      data-toggle="dropdown"
      href="#"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <font-awesome-icon
      style="margin-top: 4px; margin-right: -1px;"
      :icon="['fal', 'globe']"
    />

      {{ $t('profile.navLanguage') }}
    </span>

    <div class="dropdown-menu">
      <a @click="chnageLocale('de')" class="dropdown-item" href="#">
        <font-awesome-icon
          v-if="locale == 'de'"
          class="mr-1"
          :icon="['fal', 'check']"
        />
        <div v-else class="icon-width"></div>
        <span class="k-edit">{{ $t('profileDropDown.deLanguageText') }}</span>
      </a>

      <a @click="chnageLocale('en')" class="dropdown-item" href="#">
        <font-awesome-icon
          v-if="locale == 'en'"
          class="mr-1"
          :icon="['fal', 'check']"
        />
        <div v-else class="icon-width"></div>
        <span class="k-share">{{ $t('profileDropDown.enLanguageText') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {},
  methods: {
    chnageLocale(locale) {
      console.log('chngeLocale to:', locale);
      this.$i18n.locale = locale;
      localStorage.setItem('local-locale', locale);
      console.log('local storage:', localStorage.getItem('local-locale'));
    },
  },
};
</script>
<style scoped lang="scss">
.icon-width {
  width: 14px;
  display: inline-block;
}

.dropdown-toggle::after {
  display: none;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-item {
  padding: 0.5rem !important;
}

.dropdown-menu {
  border-radius: 2px;
  padding-top: 8px;
  padding-bottom: 8px;
  box-sizing: border-box;
  width: 200px;
  touch-action: manipulation;
}
</style>
